import { render, staticRenderFns } from "./FeedResultsPreview.vue?vue&type=template&id=ebfcf7e0&scoped=true&"
import script from "./FeedResultsPreview.vue?vue&type=script&lang=js&"
export * from "./FeedResultsPreview.vue?vue&type=script&lang=js&"
import style0 from "./FeedResultsPreview.vue?vue&type=style&index=0&id=ebfcf7e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfcf7e0",
  null
  
)

export default component.exports